/**
 * @owner @Appboy/core-objects
 *
 * @fileoverview GET handler for the "/apps/catalog_filtered_sets" endpoint
 */
import fetch from "@lib/fetch";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsCatalogFilteredSets } from "./constants";
import type {
  AppsCatalogFilteredSetsResult,
  GetAppsCatalogFilteredSetsParams,
} from "@dashboardApi/apis/appsCatalogFilteredSets/types";

export const getAppsCatalogFilteredSets = reactQueryFetcherAdapter(
  appsCatalogFilteredSets,
  (signal: AbortSignal, params: GetAppsCatalogFilteredSetsParams): Promise<AppsCatalogFilteredSetsResult> => {
    return fetch(`/apps/catalog_filtered_sets`, "GET", params, { signal });
  }
);
